import React from 'react';

import { ConfirmProvider } from 'material-ui-confirm';
import { SnackbarProvider } from 'notistack';
import ReactDOM from 'react-dom';
import { ModalProvider } from 'react-modal-hook';
import { Provider as ReduxProvider } from 'react-redux';
import { HashRouter as Router } from 'react-router-dom';
import { TransitionGroup } from 'react-transition-group';

import SnackMessage from 'components/SnackMessage';
import { AuthProvider } from 'contexts/AuthContext';
import { FeatureFlagsProvider } from 'contexts/FeatureFlagsContext';
import { ThemeProvider } from 'contexts/ThemeContext';
import store from 'store';

import App from './App';

ReactDOM.render(
  <React.StrictMode>
    <Router hashType="noslash">
      <ReduxProvider store={store}>
        <AuthProvider>
          <FeatureFlagsProvider>
            <ThemeProvider>
              <SnackbarProvider
                anchorOrigin={{ vertical: 'bottom', horizontal: 'left' }}
                content={(key, message) => (
                  <SnackMessage id={key} message={message} />
                )}
              >
                <ConfirmProvider>
                  <ModalProvider rootComponent={TransitionGroup}>
                    <App />
                  </ModalProvider>
                </ConfirmProvider>
              </SnackbarProvider>
            </ThemeProvider>
          </FeatureFlagsProvider>
        </AuthProvider>
      </ReduxProvider>
    </Router>
  </React.StrictMode>,
  document.getElementById('root'),
);
